<template>
  <v-container fluid class="h-100">
    <v-row dense>
      <v-col cols="7">
        <HMIHistory type="recommendation" />
      </v-col>
      <v-col cols="5" class="d-flex">
        <RecommendationForm
          class="flex-grow-1"
          :target="target"
          :value="targetValue"
          :loading="loading"
          @selectTarget="handleTargetSelect"
          @change="handleValueChange"
          @submit="submitRecommendation"
        />
      </v-col>
      <v-col cols="12">
        <HMIMap recommendation />
      </v-col>
    </v-row>
    <RecommendationResult :show="showResult" @close="showResult = false" />
  </v-container>
</template>

<script>
import HMIMap from "@/components/hmi/HMIMap";
import HMIHistory from "@/components/hmi/HMIHistory";
import RecommendationForm from "./fragments/recommendation.form.vue";
import RecommendationResult from "./fragments/recommendation.result.vue";
import { ADD_RECOMMENDATION } from "@/core/services/store/modules/hmi/hmi.module";
import { SET_ALERT } from "@/core/services/store/modules/alert/alert.module";

export default {
  name: "Recommendation",

  data() {
    return {
      target: "carbon",
      targetValue: undefined,
      loading: false,
      showResult: false,
    };
  },

  methods: {
    handleTargetSelect(target) {
      this.target = target;
      this.targetValue = undefined;
    },
    handleValueChange(value) {
      this.targetValue = value;
    },
    async submitRecommendation() {
      this.loading = true;
      await this.$store
        .dispatch(ADD_RECOMMENDATION, {
          carbon: this.targetValue?.carbon,
          metal: this.targetValue?.metallization,
        })
        .then(() => {
          this.showResult = true;
          this.targetValue = { carbon: null, metallization: null };
        })
        .catch((error) => {
          this.$store.commit(SET_ALERT, {
            text: error?.message,
            isError: true,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },

  components: {
    HMIMap,
    HMIHistory,
    RecommendationForm,
    RecommendationResult,
  },
};
</script>
